export const policyTypes = {
  // monolines
  Home: 'H',
  Auto: 'A',
  Renters: 'R',
  Condo: 'C',
  Farm: 'F',
  // bundles
  ARBundle: 'AR',
  HABundle: 'HA',
  CABundle: 'CA',
  FABundle: 'FA'
};

export const offerFarm = true;
